export default [
    {
        path: "/bd",
        name: "_bd",
        component: () => import("../views/Bd/index"),
        children: [
            {
                path: "index/:sportsid",
                name: "index",
                component: () => import( /* webpackChunkName: "activity" */ "../views/Bd/Index/index.vue"),
                meta: {
                    title: "首页",
                    showloading: false,
                    requiresAuth: true,
                    keepAlive: false
                }
            },
            {
                path: "match/:cateid",
                name: "match",
                component: () => import( /* webpackChunkName: "activity" */ "../views/Bd/Match/index.vue"),
                meta: {
                    title: "赛事列表",
                    showloading: false,
                    requiresAuth: true,
                    keepAlive: false
                }
            },
            {
                path: "item/:itemid/:type",
                name: "item",
                component: () => import( /* webpackChunkName: "activity" */ "../views/Bd/Item/index.vue"),
                meta: {
                    title: "列表",
                    showloading: false,
                    requiresAuth: true,
                    bgcolor: "#f8f8f8",
                    keepAlive: false
                }
            },
            {
                path: "newdetail/:id/:type",
                name: "newdetail",
                component: () => import( /* webpackChunkName: "activity" */ "../views/Bd/Detail/index.vue"),
                meta: {
                    title: "详情",
                    showloading: false,
                    requiresAuth: true,
                    keepAlive: false
                }
            },
            {
                path: "/newsports/rank/:item_sub_id/:sports_id/:item_id?",
                name: "newsportsRank",
                props:true,
                component: () => import(/* webpackChunkName: "home" */"../views/Bd/Rank/Index.vue"),
                meta: {
                    requiresAuth: true,
                    showloading: false,
                    title:"排行"
                }
            },
            {
                path: "live/:subid",
                name: "live",
                component: () => import( /* webpackChunkName: "activity" */ "../views/Bd/Live/index.vue"),
                meta: {
                    title: "教学直播",
                    showloading: false,
                    requiresAuth: true,
                    bgcolor: "#f8f8f8",
                    keepAlive: false
                }
            }
        ]
    }
]